import { getCookie, setCookie } from 'core/utils/cookie-helper';

import {
  UNITY_PAUSE_SSO_COOKIE_NAME,
  UNITY_PAUSE_SSO_COOKIE_MAX_AGE,
  REDIRECT_URI_GET_WHITE_LIST,
} from './constants';

/**
 * Функция ставит куку как признак того что нужно кратковременно прекратить делать попытки автовхода
 */
export const setOnPauseSSOSberId = () => {
  setCookie(UNITY_PAUSE_SSO_COOKIE_NAME, 1, { ['max-age']: UNITY_PAUSE_SSO_COOKIE_MAX_AGE });
};

/**
 * Функция проверяет наличие куки как признака того что автовход приостановлен
 */
export const checkOnPauseSSOSberId = () => {
  return !!getCookie(UNITY_PAUSE_SSO_COOKIE_NAME);
};

/**
 * Формируем redirect_uri с разрешенными get params
 * https://developers.sber.ru/docs/ru/sberid/service/get-params-redirect-uri
 */
export const getFilteredSearchParams = searchParams => {
  return Object.keys(searchParams)
    .filter(key => REDIRECT_URI_GET_WHITE_LIST.includes(key))
    .reduce((acc, key) => {
      const value = searchParams[key];

      acc[key] = Array.isArray(value)
        ? value.map(v => encodeURIComponent(v)).join(',')
        : encodeURIComponent(value);

      return acc;
    }, {});
};
